module.exports = __webpack_public_path__ + "img/11088025_L.9a30454b.png";